import { getJson } from './jiraClient';

class ServerApi {

    getBaseUrl() {
        return getJson('/serverInfo').then(response => response.baseUrl as string);
    }
}

export default new ServerApi();
